module.exports = __webpack_public_path__ + "img/d79d35e.jpg";